import { api } from "./api";

export const alertCreateApi = (params) => {
  return api.post(`/notification/add`, JSON.stringify(params));
};

export const alertTableApi = (params) => {
  return api.get(
    `/notification/list?sortBy=${params?.filterData?.sort_by}&sortOrder=${
      params?.filterData?.sort_order
    }&page_no=${params?.pageNumber}&from_date=${
      params?.filterData?.from
    }&to_date=${params?.filterData?.to}&searchColumn=${
      params?.filterData?.selectColumn
    }&searchValue=${params?.filterData?.inputValue}&statusFilter=${
      params?.filterData?.status
    }${
      params?.filterData?.channel_values?.length > 0
        ? `&channel_values=["${params?.filterData?.channel_values}"]`
        : ""
    }`,
    JSON.stringify(params)
  );
};

export const alertViewApi = (params) => {
  return api.get(
    `/notification/get-by-id?ntf_id=${params}`,
    JSON.stringify(params)
  );
};
export const alertEditApi = (params) => {
  return api.post(`/notification/update`, JSON.stringify(params));
};
export const alertDeleteApi = (params) => {
  return api.post(`/notification/delete`, JSON.stringify(params));
};
export const alertStatusApi = (params) => {
  return api.post(`/notification/ams-start-or-stop`, JSON.stringify(params));
};
